module.exports = "<div [ngClass]=\"fuseConfig.layout.navbar.primaryBackground\">\r\n    <fuse-navigation layout=\"horizontal\"></fuse-navigation>\r\n</div>"